module.exports = __webpack_public_path__ + "img/icn_smartphone.bffc922c.svg";